module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/recompose/~/babel-runtime/core-js/object/create.js
// module id = 1785
// module chunks = 0